import { ReactComponent as StarHighLightIcon } from '@/assets/star-highlight.svg';
import React from 'react';

import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';
import { useEventListener, useIsMounted, useLocalStorage } from 'usehooks-ts';
import TooltipCard from '../../../../components/TooltipCard';
import { useHighLights } from '../../providers/HighLightProvider';
import {
  Content,
  FeatureHighLightContainer,
  HighlightContent,
  Left,
  Right,
  StarHighLightDown,
  StarHighLightTop,
  Title,
  ToolTipContainer,
} from './styles';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  featureName: string;
  featureDescription?: string;
};

const FeatureHighLight: React.FC<Props> = ({ children, ...props }) => {
  const { user } = useAuth();
  const [highlighted, setHighlighted] = React.useState(false);
  const contentRef = React.useRef<HTMLDivElement>(null);

  const { windowLoadCount } = useHighLights();

  const isMounted = useIsMounted();

  const [total, setTotal, removeTotal] = useLocalStorage<number>(
    `@User:${user?.id}:${props.featureName}`,
    1,
  );

  useEventListener(
    'click',
    () => {
      if (user) {
        setTotal(prev => (prev <= 1 ? prev + 1 : prev));
      }
    },
    contentRef,
  );

  React.useEffect(() => {
    if (user) {
      if (isMounted()) {
        setTotal(prev => (prev <= 1 ? windowLoadCount : prev));
      }
    }
  }, [isMounted, removeTotal, setTotal, user, windowLoadCount]);

  React.useEffect(() => {
    if (total <= 1) {
      setHighlighted(true);
    } else {
      setHighlighted(false);
    }
  }, [total]);

  if (!highlighted) {
    return <>{children}</>;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FeatureHighLightContainer {...props} ref={contentRef}>
      <StarHighLightTop>
        <StarHighLightIcon />
      </StarHighLightTop>
      <StarHighLightDown>
        <StarHighLightIcon />
      </StarHighLightDown>
      <TooltipCard
        placement="bottom-start"
        delay={[500, 0]}
        offset={[0, 5]}
        content={
          <ToolTipContainer>
            <Left>
              <StarHighLightTop>
                <StarHighLightIcon />
              </StarHighLightTop>
              <StarHighLightDown>
                <StarHighLightIcon />
              </StarHighLightDown>
            </Left>
            <Right>
              <Title>Novidade</Title>
              {props.featureDescription && (
                <Content>{props.featureDescription}</Content>
              )}
            </Right>
          </ToolTipContainer>
        }
      >
        <HighlightContent>{children}</HighlightContent>
      </TooltipCard>
    </FeatureHighLightContainer>
  );
};
export default FeatureHighLight;
